export default ["input", "a", "button", "textarea", "select"]
